import { jsxs as y, jsx as a } from "react/jsx-runtime";
import { c as r } from "../../clsx-OuTLNxxd.js";
import '../../assets/Dropdown.css';/* empty css                      */
const j = ({
  children: u,
  items: i,
  placement: o = "bottom",
  open: l = !1,
  wrapperClassName: b = "",
  dropdownWrapperClassName: w = "",
  dropdownItemClassName: n = "",
  selected: t = "",
  trigger: v = "click",
  onItemClick: s
}) => {
  const x = r(
    "dropdown",
    {
      "dropdown-top": o == null ? void 0 : o.includes("top"),
      "dropdown-left": o == null ? void 0 : o.includes("left"),
      "dropdown-bottom": o == null ? void 0 : o.includes("bottom"),
      "dropdown-right": o == null ? void 0 : o.includes("right"),
      "dropdown-start": o == null ? void 0 : o.includes("start"),
      "dropdown-end": o == null ? void 0 : o.includes("end"),
      "dropdown-open": l,
      "dropdown-hover": v === "hover"
    },
    b
  ), h = r(
    // Layout and positioning
    "dropdown-content menu flex-nowrap rounded z-[1] w-[418px] max-h-[320px] mt-2 scrollbar",
    // Box model
    "p-0 overflow-auto shadow-02",
    w
  ), f = r(
    // Text styles
    "w-full block text-body-b3-medium cursor-pointer",
    // Padding
    "px-4 lg:py-5 py-4",
    // Background color
    "bg-data-display-surface-default",
    // Border styles
    "border-b-[2px] last:border-b-0 border-data-display-strokes-divider",
    // hover styles
    "hover:bg-data-display-surface-hover hover:border-data-display-strokes-hover"
  ), p = () => {
    const d = document.activeElement;
    d && "blur" in d && d.blur();
  }, e = (d) => {
    s == null || s(d), setTimeout(p, 0);
  };
  return /* @__PURE__ */ y("div", { className: x, children: [
    /* @__PURE__ */ a("div", { tabIndex: 0, role: "button", className: "cursor-pointer select-none", children: u }),
    /* @__PURE__ */ a("ul", { tabIndex: 0, className: h, children: i.map((d) => /* @__PURE__ */ a(
      "li",
      {
        "data-value": d.value,
        className: r(
          f,
          {
            "text-data-display-text-selected": t === d.value,
            "text-data-display-text-default": t !== d.value
          },
          n
        ),
        onClick: () => e(d.value),
        children: d.label
      },
      d.value
    )) })
  ] });
};
export {
  j as Dropdown
};
